import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
import { PageTransition } from '../components/PageTransition';
import { AnimatedSection } from '../components/AnimatedSection';
import { PhoneIcon, MailIcon, MapPinIcon, ClockIcon, CheckIcon } from 'lucide-react';
export const ContactPage = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: '',
    preferredContact: 'email'
  });
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  const handleSubmit = e => {
    e.preventDefault();
    // Form submission logic would go here
    console.log('Form submitted:', formData);
    alert('Thank you for your message! We will contact you soon.');
  };
  return <PageTransition data-id="element-926">
      <div className="min-h-screen bg-[#f2f2ed]" data-id="element-927">
        <Header data-id="element-928" />
        <main className="pt-32 pb-20" data-id="element-929">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-930">
            {/* Hero Section */}
            <AnimatedSection data-id="element-931">
              <div className="mb-16" data-id="element-932">
                <h1 className="text-sm uppercase tracking-wider text-[#3a4a56] font-medium mb-6" data-id="element-933">
                  CONTACT US
                </h1>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-32" data-id="element-934">
                <div data-id="element-935">
                  <h2 className="text-4xl md:text-5xl font-normal text-[#3a4a56] leading-tight mb-10" data-id="element-936">
                    Let's start a conversation about your real estate journey
                  </h2>
                </div>
                <div className="text-[#3a4a56]" data-id="element-937">
                  <p className="text-lg mb-8" data-id="element-938">
                    Whether you're looking to buy, sell, or simply explore the
                    market, our team is here to provide expert guidance tailored
                    to your unique needs.
                  </p>
                  <p className="text-lg mb-8" data-id="element-939">
                    At Immovendu, we believe that communication is the
                    foundation of successful real estate transactions. We're
                    committed to being accessible, responsive, and attentive to
                    your questions and concerns throughout the process.
                  </p>
                  <p className="text-lg" data-id="element-940">
                    Reach out today to discover how we can help you achieve your
                    real estate goals with confidence and peace of mind.
                  </p>
                </div>
              </div>
            </AnimatedSection>
            {/* Contact Information Cards */}
            <div className="border-t border-[#3a4a56] py-20" data-id="element-941">
              <AnimatedSection data-id="element-942">
                <div className="mb-16" data-id="element-943">
                  <h6 className="text-sm uppercase tracking-wider text-[#3a4a56] font-medium mb-6" data-id="element-944">
                    GET IN TOUCH
                  </h6>
                  <h2 className="text-4xl md:text-5xl font-normal text-[#3a4a56] leading-tight mb-10" data-id="element-945">
                    We're Here for You
                  </h2>
                </div>
              </AnimatedSection>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-946">
                <AnimatedSection delay={0.2} data-id="element-947">
                  <motion.div className="p-8 border-b border-[#3a4a56]" data-id="element-948">
                    <div className="flex items-center mb-6" data-id="element-949">
                      <PhoneIcon className="h-8 w-8 text-[#00A3E0] mr-4" data-id="element-950" />
                      <h3 className="text-xl font-normal text-[#3a4a56]" data-id="element-951">
                        Call Us
                      </h3>
                    </div>
                    <p className="text-[#3a4a56] mb-2" data-id="element-952">Mobile:</p>
                    <p className="text-[#3a4a56] font-medium text-lg mb-4" data-id="element-953">
                      514.659.8161
                    </p>
                  </motion.div>
                </AnimatedSection>
                <AnimatedSection delay={0.3} data-id="element-954">
                  <motion.div className="p-8 border-b border-[#3a4a56]" data-id="element-955">
                    <div className="flex items-center mb-6" data-id="element-956">
                      <MailIcon className="h-8 w-8 text-[#00A3E0] mr-4" data-id="element-957" />
                      <h3 className="text-xl font-normal text-[#3a4a56]" data-id="element-958">
                        Email Us
                      </h3>
                    </div>
                    <p className="text-[#3a4a56] mb-2" data-id="element-959">For inquiries:</p>
                    <p className="text-[#3a4a56] font-medium text-lg mb-4" data-id="element-960">
                      info@immovendu.com
                    </p>
                  </motion.div>
                </AnimatedSection>
                <AnimatedSection delay={0.4} data-id="element-961">
                  <motion.div className="p-8 border-b border-[#3a4a56]" data-id="element-962">
                    <div className="flex items-center mb-6" data-id="element-963">
                      <MapPinIcon className="h-8 w-8 text-[#00A3E0] mr-4" data-id="element-964" />
                      <h3 className="text-xl font-normal text-[#3a4a56]" data-id="element-965">
                        Visit Us
                      </h3>
                    </div>
                    <p className="text-[#3a4a56] mb-2" data-id="element-966">
                      Royal LePage du Quartier
                    </p>
                    <p className="text-[#3a4a56] font-medium text-lg mb-4" data-id="element-967">
                      6971 Ch. Côte-de-Liesse, #C
                      <br data-id="element-968" />
                      Montréal (St-Laurent), QC H4T 1Z3
                    </p>
                  </motion.div>
                </AnimatedSection>
              </div>
              <AnimatedSection delay={0.5} data-id="element-969">
                <div className="mt-12 p-8 border-b border-[#3a4a56]" data-id="element-970">
                  <div className="flex items-center mb-6" data-id="element-971">
                    <ClockIcon className="h-8 w-8 text-[#00A3E0] mr-4" data-id="element-972" />
                    <h3 className="text-xl font-normal text-[#3a4a56]" data-id="element-973">
                      Business Hours
                    </h3>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-974">
                    <div data-id="element-975">
                      <p className="text-[#3a4a56] mb-1" data-id="element-976">Monday - Friday:</p>
                      <p className="text-[#3a4a56] font-medium" data-id="element-977">
                        9:00 AM - 6:00 PM
                      </p>
                    </div>
                    <div data-id="element-978">
                      <p className="text-[#3a4a56] mb-1" data-id="element-979">Saturday:</p>
                      <p className="text-[#3a4a56] font-medium" data-id="element-980">
                        10:00 AM - 4:00 PM
                      </p>
                    </div>
                    <div data-id="element-981">
                      <p className="text-[#3a4a56] mb-1" data-id="element-982">Sunday:</p>
                      <p className="text-[#3a4a56] font-medium" data-id="element-983">Closed</p>
                    </div>
                  </div>
                </div>
              </AnimatedSection>
            </div>
            {/* Contact Form Section */}
            <div className="py-20 border-b border-[#3a4a56]" data-id="element-984">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-985">
                <AnimatedSection data-id="element-986">
                  <h2 className="text-4xl font-normal text-[#3a4a56] leading-tight mb-10" data-id="element-987">
                    Send Us a Message
                  </h2>
                  <p className="text-lg text-[#3a4a56] mb-8" data-id="element-988">
                    Have a question or ready to start your real estate journey?
                    Fill out the form and one of our experts will get back to
                    you promptly.
                  </p>
                  <ul className="space-y-4 mb-8" data-id="element-989">
                    <motion.li className="flex items-start" initial={{
                    opacity: 0,
                    x: -20
                  }} whileInView={{
                    opacity: 1,
                    x: 0
                  }} transition={{
                    duration: 0.5,
                    delay: 0.1
                  }} viewport={{
                    once: true
                  }} data-id="element-990">
                      <CheckIcon className="h-5 w-5 text-[#00A3E0] mr-3 mt-1 flex-shrink-0" data-id="element-991" />
                      <span className="text-[#3a4a56] text-lg" data-id="element-992">
                        Quick response within 24 hours
                      </span>
                    </motion.li>
                    <motion.li className="flex items-start" initial={{
                    opacity: 0,
                    x: -20
                  }} whileInView={{
                    opacity: 1,
                    x: 0
                  }} transition={{
                    duration: 0.5,
                    delay: 0.2
                  }} viewport={{
                    once: true
                  }} data-id="element-993">
                      <CheckIcon className="h-5 w-5 text-[#00A3E0] mr-3 mt-1 flex-shrink-0" data-id="element-994" />
                      <span className="text-[#3a4a56] text-lg" data-id="element-995">
                        Personalized consultation
                      </span>
                    </motion.li>
                    <motion.li className="flex items-start" initial={{
                    opacity: 0,
                    x: -20
                  }} whileInView={{
                    opacity: 1,
                    x: 0
                  }} transition={{
                    duration: 0.5,
                    delay: 0.3
                  }} viewport={{
                    once: true
                  }} data-id="element-996">
                      <CheckIcon className="h-5 w-5 text-[#00A3E0] mr-3 mt-1 flex-shrink-0" data-id="element-997" />
                      <span className="text-[#3a4a56] text-lg" data-id="element-998">
                        Confidential discussion of your needs
                      </span>
                    </motion.li>
                  </ul>
                </AnimatedSection>
                <AnimatedSection delay={0.3} data-id="element-999">
                  <form onSubmit={handleSubmit} className="space-y-6" data-id="element-1000">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1001">
                      <motion.div whileHover={{
                      y: -5
                    }} transition={{
                      type: 'spring',
                      stiffness: 500
                    }} data-id="element-1002">
                        <input type="text" id="firstName" name="firstName" value={formData.firstName} onChange={handleChange} className="w-full px-4 py-3 border-b border-[#3a4a56] bg-transparent focus:outline-none focus:border-[#00A3E0]" placeholder="First Name" required data-id="element-1003" />
                      </motion.div>
                      <motion.div whileHover={{
                      y: -5
                    }} transition={{
                      type: 'spring',
                      stiffness: 500
                    }} data-id="element-1004">
                        <input type="text" id="lastName" name="lastName" value={formData.lastName} onChange={handleChange} className="w-full px-4 py-3 border-b border-[#3a4a56] bg-transparent focus:outline-none focus:border-[#00A3E0]" placeholder="Last Name" required data-id="element-1005" />
                      </motion.div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1006">
                      <motion.div whileHover={{
                      y: -5
                    }} transition={{
                      type: 'spring',
                      stiffness: 500
                    }} data-id="element-1007">
                        <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full px-4 py-3 border-b border-[#3a4a56] bg-transparent focus:outline-none focus:border-[#00A3E0]" placeholder="Email Address" required data-id="element-1008" />
                      </motion.div>
                      <motion.div whileHover={{
                      y: -5
                    }} transition={{
                      type: 'spring',
                      stiffness: 500
                    }} data-id="element-1009">
                        <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-3 border-b border-[#3a4a56] bg-transparent focus:outline-none focus:border-[#00A3E0]" placeholder="Phone Number" data-id="element-1010" />
                      </motion.div>
                    </div>
                    <div data-id="element-1011">
                      <p className="text-[#3a4a56] mb-2" data-id="element-1012">
                        Preferred contact method:
                      </p>
                      <div className="flex space-x-6" data-id="element-1013">
                        <label className="flex items-center" data-id="element-1014">
                          <input type="radio" name="preferredContact" value="email" checked={formData.preferredContact === 'email'} onChange={handleChange} className="mr-2" data-id="element-1015" />
                          <span className="text-[#3a4a56]" data-id="element-1016">Email</span>
                        </label>
                        <label className="flex items-center" data-id="element-1017">
                          <input type="radio" name="preferredContact" value="phone" checked={formData.preferredContact === 'phone'} onChange={handleChange} className="mr-2" data-id="element-1018" />
                          <span className="text-[#3a4a56]" data-id="element-1019">Phone</span>
                        </label>
                      </div>
                    </div>
                    <motion.div whileHover={{
                    y: -5
                  }} transition={{
                    type: 'spring',
                    stiffness: 500
                  }} data-id="element-1020">
                      <textarea id="message" name="message" value={formData.message} onChange={handleChange} className="w-full px-4 py-3 border-b border-[#3a4a56] bg-transparent focus:outline-none focus:border-[#00A3E0]" rows={4} placeholder="How can we help you? Tell us about your real estate needs." required data-id="element-1021"></textarea>
                    </motion.div>
                    <div data-id="element-1022">
                      <motion.button type="submit" className="bg-[#3a4a56] hover:bg-[#2a3a46] text-white font-medium py-3 px-8 transition duration-200" whileHover={{
                      scale: 1.05
                    }} whileTap={{
                      scale: 0.95
                    }} data-id="element-1023">
                        Submit
                      </motion.button>
                      <p className="text-sm text-[#3a4a56] mt-4" data-id="element-1024">
                        By submitting this form, you agree to our privacy policy
                        and terms of service.
                      </p>
                    </div>
                  </form>
                </AnimatedSection>
              </div>
            </div>
            {/* Map Section */}
            <AnimatedSection data-id="element-1025">
              <div className="py-20" data-id="element-1026">
                <div className="mb-16" data-id="element-1027">
                  <h6 className="text-sm uppercase tracking-wider text-[#3a4a56] font-medium mb-6" data-id="element-1028">
                    FIND US
                  </h6>
                  <h2 className="text-4xl md:text-5xl font-normal text-[#3a4a56] leading-tight mb-10" data-id="element-1029">
                    Our Location
                  </h2>
                </div>
                <motion.div className="border border-[#3a4a56] p-4" initial={{
                opacity: 0,
                scale: 0.9
              }} whileInView={{
                opacity: 1,
                scale: 1
              }} transition={{
                duration: 0.5
              }} viewport={{
                once: true
              }} data-id="element-1030">
                  {/* This would typically be a map component, but for now we'll use a placeholder */}
                  <div className="h-96 bg-gray-200 flex items-center justify-center" data-id="element-1031">
                    <p className="text-[#3a4a56] text-lg" data-id="element-1032">
                      Interactive Map Would Be Embedded Here
                    </p>
                  </div>
                </motion.div>
                <div className="mt-8 text-center" data-id="element-1033">
                  <motion.a href="https://maps.google.com" target="_blank" rel="noopener noreferrer" className="text-[#00A3E0] hover:text-[#0089BD] border-b border-[#00A3E0] hover:border-[#0089BD] transition" whileHover={{
                  scale: 1.05
                }} whileTap={{
                  scale: 0.95
                }} data-id="element-1034">
                    Get Directions
                  </motion.a>
                </div>
              </div>
            </AnimatedSection>
          </div>
        </main>
        <Footer data-id="element-1035" />
      </div>
    </PageTransition>;
};